import { CheckCircle, Close } from '@mui/icons-material';
import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  description: React.ReactNode;
  cancelProps: ButtonProps;
  confirmProps: ButtonProps;
  /** Optional middle action rendered between Cancel and Confirm. */
  actionProps?: ButtonProps;
  /** Optional bullet-list rendered beneath the description. */
  items?: React.ReactNode[];
}

const ConfirmationDialog = ({
  open,
  title,
  description,
  cancelProps,
  confirmProps,
  actionProps,
  items,
}: Props) => {
  /* Hooks & Use Effects */

  /* States */

  /* API Calls */

  /* Functions & Functional Components */

  return (
    <Dialog open={open} onClose={cancelProps.onClick}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>{description}</DialogContentText>
        {items && items.length > 0 && (
          <List dense sx={{ listStyleType: 'disc', pl: 4, pt: 1 }}>
            {items.map((item, index) => (
              <ListItem
                key={index}
                sx={{ display: 'list-item', py: 0, pl: 0 }}
                disableGutters
              >
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{ color: 'text.secondary' }}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pt: 2, pb: 2 }}>
        <Button {...cancelProps} endIcon={cancelProps.endIcon ?? <Close />}>
          {cancelProps.children ?? 'Cancel'}
        </Button>
        {actionProps && (
          <Button {...actionProps}>{actionProps.children}</Button>
        )}
        <Button
          {...confirmProps}
          endIcon={confirmProps.endIcon ?? <CheckCircle />}
          variant={confirmProps.variant ?? 'outlined'}
        >
          {confirmProps.children ?? 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
